import { render } from "./SmartQaWorkstation.vue?vue&type=template&id=2b2dbfe2&scoped=true"
import script from "./SmartQaWorkstation.vue?vue&type=script&lang=js"
export * from "./SmartQaWorkstation.vue?vue&type=script&lang=js"

import "./SmartQaWorkstation.vue?vue&type=style&index=0&id=2b2dbfe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2dbfe2"]])

export default __exports__